import { useCallback } from 'react';
import BarChartScenario from '../bar-chart-scenario/BarChartScenario';
import { BarChartByProps } from '../config';
import { useTranslation } from 'react-i18next';
import { ScenarioDataSetLabelV2, ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import { CustomBarChartLabel, OnCategorySelect } from '../bar-select/BarSelectPlugin';
import { isEnumValue } from '@cas/utils/typeHelpers';
import { saveFilters, setGeofenceInteractionTypes } from '@customer/store/slices/filtersSlice';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { GIType } from '@customer/store/apis/interactionsApi';
import { GetTooltipTitle } from '../utils';

export const BarChartByGeofenceInteractionType = <T extends ScenarioQueryParams>(
  props: BarChartByProps,
) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const siteId = useAppSelector(state => state.auth.siteId);

  const getGeofenceInteractionTypeLabel = useCallback(
    (label: ScenarioDataSetLabelV2) => {
      return t(`gi.name.${label.name}`);
    },
    [t],
  );

  const getTooltipTitle = useCallback<GetTooltipTitle>(
    (_, categoryLabelKey) => {
      return t(`gi.name.${categoryLabelKey}`);
    },
    [t],
  );

  // The Geofence Interaction Type chart does not have filterable dataset segments,
  // so the onCategorySelect function can also be used for the onBarSelect callback.
  const onCategorySelect = useCallback<OnCategorySelect>(
    ({ name }: CustomBarChartLabel): void => {
      if (siteId && isEnumValue(name, GIType)) {
        dispatch(setGeofenceInteractionTypes([name]));
        dispatch(saveFilters(siteId));
      }
    },
    [dispatch, siteId],
  );

  return (
    <BarChartScenario<T>
      {...props}
      getCategoryLabel={getGeofenceInteractionTypeLabel}
      getTooltipTitle={getTooltipTitle}
      onCategorySelect={onCategorySelect}
      onBarSelect={onCategorySelect}
    />
  );
};

export default BarChartByGeofenceInteractionType;
